import { usePermissions } from 'react-admin';
import { hasPermission } from '../utils/hasPermission';

/**
 * Hook for gating "total sessions" UI elements (KPIs, columns, chart series,
 * CSV columns) on the `reports:total-sessions:read` permission.
 *
 * Default is `false` (charged sessions only). Roles get the permission via
 * the Roles admin UI — see backend migration 215 for the default grant
 * (role_admin only).
 *
 * Returns false during permission load so total-session UI doesn't briefly
 * flash before the gate evaluates.
 */
export function useCanSeeTotalSessions(): boolean {
  const { permissions, isLoading } = usePermissions();
  if (isLoading) return false;
  return hasPermission(permissions as string[] | null | undefined, 'reports:total-sessions:read');
}
